// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"5f83af46","833":"fc9bc529","944":"5f83af46"}[chunkId] + ".chunk.css";
};